// Validator
import { isEmail } from "validator";
import { isValidPhone, isValidNumber } from "constants/utils/validator";

export const validField = (name, value, plainPassword = null) => {
  switch (name) {
    case "fullname":
      return value.length >= 2 && value.length <= 255;
    case "email":
      return isEmail(value);
    case "tel":
      return isValidPhone(value) && value.length >= 11 && value.length <= 25;
    case "toge":
      return isValidNumber(value) && value.length >= 0;
    case "plainPassword":
      return !value || (value.length >= 4 && value.length <= 25);
    case "confirmPassword":
      return value === plainPassword;
    default:
      return true;
  }
};

export const validForm = (fields) => {
  const { email, fullname, tel, plainPassword } = fields;
  return (
    isEmail(email.value) &&
    fullname.value.length >= 4 &&
    fullname.value.length <= 255 &&
    isValidPhone(tel.value) &&
    tel.value.length >= 11 &&
    tel.value.length <= 25 &&
    (!plainPassword.value || (plainPassword.value.length >= 4 && plainPassword.value.length <= 25))
  );
};

export const validProfileForm = (fields) => {
  const { email, fullname, tel, plainPassword, confirmPassword } = fields;
  return (
    isEmail(email.value) &&
    fullname.value.length >= 4 &&
    isValidPhone(tel.value) &&
    tel.value.length >= 11 &&
    tel.value.length <= 25 &&
    (!plainPassword.value ||
      (plainPassword.value.length >= 4 &&
        plainPassword.value.length <= 25 &&
        confirmPassword.value === plainPassword.value))
  );
};
